import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { CopyInformationService } from '../services/copy-information.service';
import { CopiedType } from '../enums/copied-type';

@Directive({
  selector: '[appCopyData]',
})
export class CopyDataDirective {
  @Input() dataCopy!: string | string[] | object[];
  @Input() title!: string;
  @Input() copiedType!: CopiedType;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private copyInformationService: CopyInformationService
  ) { }

  @HostListener('document:click', ['$event.target'])
  public onClick(target: EventTarget | null): void {
    const data = this.elementRef.nativeElement.contains(target as Node);
    if (data) {
      this.copyInformationService.copy(
        this.dataCopy,
        this.copiedType,
        this.title,
        false
      );
    }
  }
}
